import { datadogLogs } from '@datadog/browser-logs'

const init = () => {
  const dataDogClientToken = process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN
  const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT
  const isLocalEnvironment = (environment ?? 'local') === 'local'
  const isTestEnvironment = process.env.NODE_ENV === 'test'

  if (!dataDogClientToken || isLocalEnvironment || isTestEnvironment) {
    return
  }

  // RUM disabled for legal/privacy review (issue #358); only browser-log error forwarding kept.
  datadogLogs.init({
    clientToken: dataDogClientToken,
    service: 'web',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

init()
